const SUBSIDIZED_PROMOTED_ORDER = -1;
const SUBSIDIZED_DEMOTED_ORDER = 999;
const ISRACARD_ORDER = 1000;

const getSliderOrderNum = (slider, item) => {
    const raw = slider?.homepage_order_num ?? item?.orderNum ?? 0;
    const orderNum = Number(raw);
    return Number.isFinite(orderNum) ? orderNum : 0;
};

const isIsracardSlider = (slider) => {
    const value = slider?.is_isracard_slider ?? slider?.isIsracardSlider;
    return value === true || value === 1 || value === '1';
};

const sortByHomepageOrder = (sliders) => {
    sliders.sort((s1, s2) => {
        return Number(s1.slider.homepage_order_num) - Number(s2.slider.homepage_order_num);
    });
    return sliders;
};

/**
 * Matches mobile MainScreen.sortSubsidizedSlider:
 * - subsidized unused → top (-1)
 * - subsidized already used (demoteSubsidySlider) → near end (999)
 * - isracard → end (1000)
 * Magazine (if present) keeps its API order untouched.
 */
const sortSubsidizedSlider = (sliders, demoteSubsidySlider) => {
    sliders.forEach((item) => {
        const slider = item.slider;
        if (!slider) {
            return;
        }

        if (isIsracardSlider(slider)) {
            slider.homepage_order_num = ISRACARD_ORDER;
        }

        if (slider.is_subsidized) {
            slider.homepage_order_num = demoteSubsidySlider
                ? SUBSIDIZED_DEMOTED_ORDER
                : SUBSIDIZED_PROMOTED_ORDER;
        }
    });

    return sortByHomepageOrder(sliders);
};

export const buildHomepageSliders = (homepageData, userData, recommendationsSliderPayload) => {
    const demoteSubsidySlider = !!userData?.demoteSubsidySlider;

    const transformSliderItem = (item) => {
        if (!item) {
            return null;
        }

        const sliderPayload = item.slider ?? item;
        const slider = {
            ...sliderPayload,
            homepage_order_num: getSliderOrderNum(sliderPayload, item),
        };

        return {
            ...item,
            slider,
        };
    };

    let slidersTemp = (homepageData?.Sliders || [])
        .map(transformSliderItem)
        .filter(Boolean);

    const recEntry = userData ? recommendationsSliderPayload : null;
    const parsedRec = transformSliderItem(recEntry);
    if (parsedRec) {
        slidersTemp = [parsedRec, ...slidersTemp];
    }

    slidersTemp = sortByHomepageOrder(slidersTemp);
    slidersTemp = sortSubsidizedSlider(slidersTemp, demoteSubsidySlider);

    return slidersTemp.map((sliderData, sliderIndex) => ({
        ...sliderData,
        uniqueId: `homepage-slider_${sliderIndex}`,
    }));
};
